module.exports = __webpack_public_path__ + "static/media/trafficlightred.4481a323.png";